import React from 'react';

import PropTypes from 'prop-types';

import { PromoDangerouslyHtml } from './PromoDangerouslyHtml';

export const RichText = (props) => {
    return (
        <div className={'richTextWrapper'} data-testid={props.dataTestId}>
            <PromoDangerouslyHtml
                variant={props.variant}
                tag={props.tag}
                color={props.color}
                gradientColor={props.gradientColor}
                nowrap={props.nowrap}
                ellipsis={props.ellipsis}
                textAlign={props.textAlign}
                isBold={props.isBold}
                dangerouslyHtml={props.dangerouslyHtml}
            />
        </div>
    );
};

RichText.propTypes = {
    dangerouslyHtml: PropTypes.string,
    variant: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'subheader', 'quote', 'div', 'span', 'link', 'label', 'note']),
    tag: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'div', 'span', 'link', 'label', 'p']),
    color: PropTypes.oneOf(['baseColor', 'primary', 'primaryB2B', 'purple80', 'purple40', 'purple20', 'gray80', 'gray40', 'gray20', 'white']),
    gradientColor: PropTypes.oneOf([
        'aubergine01',
        'aubergine02',
        'aubergine03',
        'passionFruit01',
        'passionFruit02',
        'passionFruit03',
        'oceanBlue01',
        'oceanBlue02',
        'oceanBlue03',
        'blueberryBlue01',
        'blueberryBlue02',
        'blueberryBlue03',
        'jade01',
        'jade02',
        'jade03',
    ]),
    nowrap: PropTypes.bool,
    ellipsis: PropTypes.bool,
    textAlign: PropTypes.string,
    isBold: PropTypes.bool,
    dataTestId: PropTypes.string,
};
